<template>
  <el-row class="pengdingMyOrders">
    <el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>问题搜索</span>
        </div>
        <div class="text item">
          <el-form :inline="true" ref="orderForm" :model="orderForm" size="small">
            <el-form-item label="输入查询：" prop="keywords">
              <el-input clearable v-model="orderForm.keywords" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item label="入库时间：" prop="time">
              <el-date-picker
                  v-model="orderForm.time"
                  value-format="timestamp"
                  format="yyyy 年 MM 月 dd 日"
                  unlink-panels
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="问题类型：" prop="type">
              <el-select clearable v-model="orderForm.type">
                <el-option v-for="item in datatype" :label="item.text" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="qsSerch('orderForm')">查询</el-button>
              <el-button @click="resetForm('orderForm')">重置</el-button>
              <el-button type="primary" @click="qsAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <div class="tables">
          <el-table :data="tableData" @cell-click="cellClick" border style="width: 100%">
            <el-table-column prop="title" label="问题题目">
            </el-table-column>
            <el-table-column prop="goods_model" label="型号">
            </el-table-column>
            <el-table-column prop="update_time" label="最后修改时间">
            </el-table-column>
            <el-table-column prop="publish_person_name" label="入库人">
            </el-table-column>
            <el-table-column prop="type" label="工单类型">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small">
                  <el-popconfirm confirm-button-text='是的'  cancel-button-text='取消' icon="el-icon-info" icon-color="#66b1ff"
                    title="请问是否删除？" @confirm="confirmEvent(scope,tableData)"  >
                    <el-button slot="reference" type="text" size="small">删除</el-button>
                  </el-popconfirm>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pages">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            @current-change="currentClick">
          </el-pagination>
        </div>
      </el-card>
    </el-row>
  </el-row>
</template>

<script>
import { getOrderType,getqsTable,questionSearch,removeQs } from '../../utils/api'
export default {
  components: {},
  props: {},
  data() {
    return {
      total:0,
      page:1,
      pageSize:5,
      orderForm: {
        keywords: '',
        type: '',
        time: '',
      },
      tableData: [],
      datatype: [],
    };
  },
  watch: {
    "orderForm.time"(value){
      if(value == null){
        this.orderForm.time = ''
      }
    }
  },
  computed: {},
  methods: {
    //获取工单类型
    getOrType() {
      var that = this
      getOrderType()
        .then(res => {
          console.log(res, '工单');
          if(res.message.status == 'success'){
            that.datatype = []
            res.data.forEach(item => {
            that.datatype.push({ text: item.type, value: item.type })
          })
          }
        })
    },
    //编辑
    editClick(row) {
      console.log(row,'编辑');
      this.$router.push({ name: 'reviseLssues' ,params:{title:'修改问题',row:row}})
    },
    //新增
    qsAdd() {
      this.$router.push({ name: 'addQuestion'})
    },
    //删除
    confirmEvent(row,tableData) {
      console.log(row, 'row');
      console.log(tableData,'ttttttt');
      var that = this
      var params = {
        id:row.row.id
      }
      removeQs(params)
      .then(res=>{
        console.log(res,'res');
        if(res.message.status == 'success'){
          tableData.splice(tableData.$index,1)
          that.$message.success(res.message.text)
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    deleteRow(index,rows){
      rows.splice(index, 1);
    },
    cellClick(row, column, cell, event){
      if(column.label == '问题题目'){
        console.log(row,'row');
          this.$router.push('/quesDetail?jumpId='+(row.id))
      }
    },
    //当前页
    currentClick(e){
        var that = this
        that.page = e
        if( that.orderForm.time !== ''  || that.orderForm.keywords !== '' || that.orderForm.type !== ''){
          that.qsSerch()
        }else{
          that.getQuesTable()
        }
    },
    //问题查询
      qsSerch(){
        var that = this
        var times = that.orderForm.time
        var params = {
          page : that.page,
          pagesize : that.pageSize,
          keywords:that.orderForm.keywords,
          type: that.orderForm.type,
          begin:times[0]/1000,
          end:times[1]/1000
        }
        questionSearch(params)
        .then(res=>{
          console.log(res,'问题查询');
          if(res.message.status == 'success'){
            that.tableData = res.data
            that.tableData.forEach(item=>{
              // item.update_time = that.getTimeship(item.update_time)
              if(item.update_time){
                item.update_time = that.getTimeship(item.update_time)
              }else{
                item.update_time = '---'
              }
            })
            that.total = res.total
          }else{
            that.$message.error(res.message.text)
            that.tableData = []
          }
        })
        .catch(err=>{
          console.log(err,'err');
        })
      },
    //问题列表
    getQuesTable(){
      var that = this
      var params = {
        page:that.page,
        pagesize:that.pageSize
      }
      getqsTable(params)
      .then(res=>{
        console.log(res,'问题列表');
        if(res.message.status == 'success'){
            that.tableData = res.data
            that.tableData.forEach(item=>{
              // item.update_time = that.getTimeship(item.update_time)
              if(item.update_time){
                item.update_time = that.getTimeship(item.update_time)
              }else{
                item.update_time = '---'
              }
            })
            that.total = res.total
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //重置
    resetForm(form){
      this.$refs[form].resetFields()
    }
  },
  created() { },
  mounted() {},
  activated(){
    this.getOrType();
    this.getQuesTable()
  },
};
</script>
<style lang="scss" scoped>
.pengdingMyOrders{
  .pages{
    text-align: right;
    margin-top: 20px;
  }
}
</style>